import { render, staticRenderFns } from "./legal_notices.vue?vue&type=template&id=00633cf0&scoped=true&"
import script from "./legal_notices.vue?vue&type=script&lang=js&"
export * from "./legal_notices.vue?vue&type=script&lang=js&"
import style0 from "./legal_notices.vue?vue&type=style&index=0&id=00633cf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00633cf0",
  null
  
)

export default component.exports